import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  message: string;
  confirmLabel: string;
  rejectLabel: string;

  constructor(
    private ref: DynamicDialogRef, 
    private config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    if (this.config && this.config.data) {
      this.message = this.config.data.message;
      this.confirmLabel = this.config.data.confirmLabel;
      this.rejectLabel = this.config.data.rejectLabel;
    }
  }

  onReject() {
    this.ref.close(false);
  }

  onConfirm() {
    this.ref.close(true);
  }

}
